import React, {useState, useEffect} from 'react'
import './../../App.css';
import './Reports.css';
import axios from '../../api/apiClient';
import { CreateSearchBarWithPlaceHolder } from '../CommonObjects';
import {CreateTableForEmployeeSelect} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import jsPDF from "jspdf";
//icons
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";

function Report201({isHideSideMenu}) {
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [company, setCompany] = useState([]);

    const [employeeInfo, setEmployeeInfo] = useState([]);

    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [errorState, setErrorState] = useState(false);

    const formatName = (name) => {
        if(name){
            const nameParts = name.split(", ");
            const formattedName = nameParts.map(part => {
                return part.split('-').map(subPart => 
                    subPart.charAt(0).toUpperCase() + subPart.slice(1).toLowerCase()
                ).join('-');
            }).join(", ");

            return formattedName.replace(/\b\w/g, (match) => match.toUpperCase());
        }
        return "";
    };

    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }

    const generate = () =>{
        if(!employeePersonalInformationId || !company){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        downloadPDF();
    };

    const downloadPDF = () => {
        // Create a new jsPDF instance
        const _doc = new jsPDF();

        const drawLine = (doc, lineX, lineY) =>{
            // doc.setDrawColor("#668fca");
            const reportTextWidth = doc.getStringUnitWidth("Employee 201 File Report") * 16; // Width of the text
            const startX = lineX;
            const endX = startX + reportTextWidth;
            const startY = lineY;
            doc.line(startX, startY, endX, startY);
        }
        const title = (doc, title, titleX, titleY) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            // doc.setTextColor("#668fca");
            doc.setLineWidth(0.5);
            doc.text(title, titleX, titleY);
        }
        const subTitle = (doc, text, x, y, options = {}) => {
            const { fontSize = 12, color = "#000000", thickness = 0.5, lineHeightRatio = 0.1 } = options;
        
            doc.setFont("helvetica", "bold");
            doc.setFontSize(fontSize);
            doc.setTextColor(color);
            doc.text(text, x, y);
        
            const textWidth = doc.getTextWidth(text);
            const underlineY = y + (fontSize * lineHeightRatio);
        
            doc.setLineWidth(thickness);
            doc.line(x, underlineY, x + textWidth, underlineY);
        };
        const infoWithValue = (doc, label, labelX, labelY, value, valueX, valueY, maxWidth) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            // doc.setTextColor("#668fca");
            doc.text(label, labelX, labelY); 
            doc.setFont("helvetica", "normal");
            // doc.setTextColor("#686868");
            const splitText = doc.splitTextToSize(value, maxWidth); // Split the text into lines based on maxWidth
            doc.text(splitText, valueX, valueY);
        }
        const singleInfo = (doc, label, labelX, labelY) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            // doc.setTextColor("#668fca");
            doc.text(label, labelX, labelY);
        }
        const decimalConverter = (value) =>{
            if(!value){
                return "";
            }
            return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }

        const halfPageWidth = _doc.internal.pageSize.getWidth() / 2;
        const secondInfoX = halfPageWidth + 5;
        
        if(company?.logo){
        const imgData = `data:image/png;base64,${company.logo}`;
        _doc.addImage(imgData, 'PNG', 5, 5, 70, 30);
        }

        title(_doc, "Employee 201 File Report", 10, 35);
        drawLine(_doc, 10, 37.5);

        infoWithValue(_doc, "Company Name: ", 10, 45, employeeInfo.employeeInformation.companyName, 50, 45);
        infoWithValue(_doc, "Employee Id: ", 10, 50, employeeInfo.employeeId, 50, 50);
        infoWithValue(_doc, "Employee Name: ", 10, 55, formatName(employeeInfo.fullName), 50, 55);

        subTitle(_doc, "Basic Information", 10, 65, { fontSize: 9, thickness: 0.5 });
        infoWithValue(_doc, "Date of Birth: ", 10, 70, employeeInfo.dateOfBirth ?? "", 50, 70);
        infoWithValue(_doc, "Gender: ", 10, 75, employeeInfo.gender ?? "", 50, 75);
        infoWithValue(_doc, "Marital Status: ", 10, 80, employeeInfo.civilStatus ?? "", 50, 80);
        infoWithValue(_doc, "Address: ", 10, 85, `${employeeInfo.blkLot} ${employeeInfo.street} ${employeeInfo.barangay} ${employeeInfo.city}`, 50, 60, 85);
        infoWithValue(_doc, "Contact No: ", 10, 95, employeeInfo.mobileNumber, 50, 95);
        infoWithValue(_doc, "Email: ", 10, 100, employeeInfo.emailAddress, 50, 100);
        infoWithValue(_doc, "Tin: ", secondInfoX, 70, employeeInfo.employeeAccountInformation.tin ?? "", secondInfoX + 50, 70);
        infoWithValue(_doc, "SSS ID: ", secondInfoX, 75, employeeInfo.employeeAccountInformation.sss ?? "", secondInfoX + 50, 75);
        infoWithValue(_doc, "BP No: ", secondInfoX, 80, "", secondInfoX + 50, 80);
        infoWithValue(_doc, "HDMF: ", secondInfoX, 85, "", secondInfoX + 50, 85);
        infoWithValue(_doc, "Philhealth: ", secondInfoX, 90, employeeInfo.employeeAccountInformation.philhealth ?? "", secondInfoX + 50, 90);
        infoWithValue(_doc, "Employment Status: ", secondInfoX, 95, employeeInfo.employeeInformation.employmentDescription ?? "", secondInfoX + 50, 95);

        subTitle(_doc, "Payroll Information", 10, 115, { fontSize: 9, thickness: 0.5 });
        infoWithValue(_doc, "Department: ", 10, 120, employeeInfo.employeeInformation.departmentDescription ?? "", 50, 120);
        infoWithValue(_doc, "Sub Department: ", 10, 125, "", 50, 125);
        infoWithValue(_doc, "Employment Type: ", 10, 130, employeeInfo.employeeInformation.employmentDescription ?? "", 50, 130);
        infoWithValue(_doc, "Rank: ", 10, 135, "", 50, 135);
        infoWithValue(_doc, "Position: ", 10, 140, employeeInfo.employeeInformation.positionDescription ?? "", 50, 140);
        infoWithValue(_doc, "Date Hired: ", 10, 145, employeeInfo.employeeInformation.dateEmployed ?? "", 50, 145);
        infoWithValue(_doc, "Last Date: ", 10, 150, "", 50, 150);
        infoWithValue(_doc, "Tax Status: ", 10, 155, "", 50, 155);
        infoWithValue(_doc, "Basic Pay Amount: ", 10, 160, employeeInfo.employeeSalary ? decimalConverter(employeeInfo.employeeSalary.salary) : decimalConverter(0), 50, 160);
        infoWithValue(_doc, "Pay Type: ", 10, 165, employeeInfo.employeeInformation.payTypeDescription ?? "", 50, 165);
        infoWithValue(_doc, "Payment Method: ", 10, 170, employeeInfo.employeeInformation.classificationDescription ?? "", 50, 170);
        infoWithValue(_doc, "Bank Route: ", 10, 175, "", 50, 175);
        infoWithValue(_doc, "Account Type: ", 10, 180, "", 50, 180);
        infoWithValue(_doc, "Payroll Group: ", 10, 185, "", 50, 185);
        infoWithValue(_doc, "Default Project: ", 10, 190, "", 50, 190);
        infoWithValue(_doc, "Time Sheet Approval: ", 10, 195, "", 50, 195);
        infoWithValue(_doc, "Overtime Approval: ", 10, 200, "", 50, 200);
        infoWithValue(_doc, "COS Approval Group: ", 10, 205, "", 50, 205);

        infoWithValue(_doc, "Deduct For SSS Contribution: ", secondInfoX, 155, "false", secondInfoX + 70, 155);
        infoWithValue(_doc, "Fixed Contribution Amount (SSS): ", secondInfoX, 160, decimalConverter(0), secondInfoX + 70, 160);
        infoWithValue(_doc, "Fixed Contribution Rate (SSS): ", secondInfoX, 165, decimalConverter(0), secondInfoX + 70, 165);
        infoWithValue(_doc, "Deduct HDMF Contribution: ", secondInfoX, 170, "false", secondInfoX + 70, 170);
        infoWithValue(_doc, "Fixed Contribution Amount (HDMF): ", secondInfoX, 175, decimalConverter(0), secondInfoX + 70, 175);
        infoWithValue(_doc, "Fixed Contribution Rate (HDMF): ", secondInfoX, 180, decimalConverter(0), secondInfoX + 70, 180);
        infoWithValue(_doc, "Deduct Philhealth Contribution: ", secondInfoX, 185, "false", secondInfoX + 70, 185);
        infoWithValue(_doc, "Fixed Contribution Amount (Philhealth): ", secondInfoX, 190, decimalConverter(0), secondInfoX + 70, 190);
        infoWithValue(_doc, "Fixed Contribution Rate (Philhealth): ", secondInfoX, 195, decimalConverter(0), secondInfoX + 70, 195);
        infoWithValue(_doc, "Deduct Withholding Tax: ", secondInfoX, 200, "false", secondInfoX + 70, 200);
        infoWithValue(_doc, "Cost Center: ", secondInfoX, 205, "", secondInfoX + 70, 205);

        subTitle(_doc, "Qualified Dependents", 10, 225, { fontSize: 9, thickness: 0.5 });
        singleInfo(_doc, "Dependent's Name", 10, 230);
        singleInfo(_doc, "Date of Birth", 50, 230);

        subTitle(_doc, "Training Details", 10, 255, { fontSize: 9, thickness: 0.5 });
        singleInfo(_doc, "Course Name", 10, 260);
        singleInfo(_doc, "Date From", 50, 260);
        singleInfo(_doc, "Date To", 100, 260);

        subTitle(_doc, "Employee Fixed", 10, 285, { fontSize: 9, thickness: 0.5 });
        singleInfo(_doc, "Allowance Type", 10, 290);
        singleInfo(_doc, "Amount", 50, 290);
        singleInfo(_doc, "Taxable", 100, 290);

        // Save the PDF
        _doc.save("Employee_201_File.pdf");
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo shadow-xl">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"201 Report"}</span>
                            </div>
                            <h3>Generate 201 Report</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row">
                                <div className="info-item2 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Employee</div>
                                    <div className="info-item-input">
                                        <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Employee"
                                                value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowEmployeeForm(true)}
                                            ><SearchIcon/></button>
                                        </div>
                                        <span style={{
                                                visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                        {/* {EmployeeIdSelect(employeePersonalInformationId, setEmployeePersonalInformationId)} */}
                                    </div>
                                </div>
                                <div className="info-item2 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect company={company} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !company && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row" style={{justifyContent:"start"}}>
                                <button id="sssReportGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
                    setEmployeeInfo={setEmployeeInfo}
            >
            </EmployeeSelectForm>
        </div>
    )
}

function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee,
    setEmployeeInfo
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        setEmployeeInfo(selectedEmployee);
        fetchData();
    };

    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    
    const [currentPage, setCurrentPage] = useState(1);
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function CompanyTypeSelect({company, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
            setIsSelected(true);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (company !== "" && company !== 0 && company !== null && company !== undefined && company.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [company]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={company} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((company) => ( 
                SetCompanyType(company)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(company){
    return(
        <option value={company.id}>{
            company.name}
        </option>
    )

}


export default Report201
